var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBetshop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "betshop",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.6 12 13.3.6h-9L.8 10.4c-.2.3-.2.7-.2 1 0 2.4 2.5 4.4 5.6 4.4 2.8 0 5.1-1.7 5.5-3.8Zm8.4 3.8c3 0 5.6-2 5.6-4.4v-.2L24.4.6h-8.9l-1 10.6v.2c0 2.4 2.4 4.4 5.5 4.4ZM30.8 18v8.5H9.2V18a9.1 9.1 0 0 1-4.4.4v13.8a3 3 0 0 0 3 3h24.3a3 3 0 0 0 3-3V18.5l-1.2.1a9 9 0 0 1-3-.5Zm8.5-7.7L35.6.6h-9L28.5 12c.3 2.1 2.7 3.8 5.5 3.8 3.1 0 5.6-2 5.6-4.4 0-.3 0-.7-.2-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBetshop);
export default __webpack_public_path__ + "static/media/icon-betshop.2455220cef892aad2cb6c743c4977f55.svg";
export { ForwardRef as ReactComponent };